import styled from 'styled-components'

export default styled.h1`
  text-decoration: underline;
`